export default {
  woundType: {
    selectedParameterCode: '',
  },
};
